var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-menu"},_vm._l((_vm.data),function(item,index){return _c('router-link',{key:item.id,class:_vm.activeItem==index?'active':'',attrs:{"to":item.url},nativeOn:{"click":function($event){return _vm.active(index)}}},[_vm._v(_vm._s(item.title))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d13a922","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/components/SideMenu.vue
// module id = null
// module chunks = 